import React from 'react';
import { HomeIcon, CalendarIcon, UsersIcon, InfoIcon } from 'lucide-react';
import { motion } from 'framer-motion';
interface BottomNavProps {
  activeTab: string;
  setActiveTab: (tab: string) => void;
}
export function BottomNav({
  activeTab,
  setActiveTab
}: BottomNavProps) {
  const tabs = [{
    id: 'home',
    label: 'Home',
    icon: HomeIcon
  }, {
    id: 'schedule',
    label: 'Schedule',
    icon: CalendarIcon
  }, {
    id: 'sessions',
    label: 'Sessions',
    icon: UsersIcon
  }, {
    id: 'info',
    label: 'Info',
    icon: InfoIcon
  }];
  return <div className="absolute bottom-0 w-full max-w-md bg-white/80 backdrop-blur-xl border-t border-gray-200/50 pb-safe z-50 shadow-[0_-4px_20px_rgba(0,0,0,0.05)]" data-id="element-11">
      <div className="flex justify-around items-center h-20 px-2 relative" data-id="element-12">
        {tabs.map(tab => {
        const Icon = tab.icon;
        const isActive = activeTab === tab.id;
        return <button key={tab.id} onClick={() => setActiveTab(tab.id)} className={`relative flex flex-col items-center justify-center w-full h-full space-y-1.5 transition-colors duration-300 ${isActive ? 'text-[#7B2D8E]' : 'text-gray-400 hover:text-gray-600'}`} data-id="element-13">
              {/* Active Indicator Top Border Glow */}
              {isActive && <motion.div layoutId="activeTabGlow" className="absolute top-0 w-12 h-[2px] bg-[#D4A017] shadow-[0_2px_8px_rgba(212,160,23,0.6)] rounded-b-full" transition={{
            type: 'spring',
            stiffness: 300,
            damping: 30
          }} data-id="element-14" />}

              <div className="relative" data-id="element-15">
                <motion.div animate={{
              scale: isActive ? 1.15 : 1,
              y: isActive ? -2 : 0
            }} transition={{
              type: 'spring',
              stiffness: 400,
              damping: 25
            }} data-id="element-16">
                  <Icon className={`w-6 h-6 ${isActive ? 'stroke-[2.5]' : 'stroke-[1.5]'}`} data-id="element-17" />
                </motion.div>

                {isActive && <motion.span initial={{
              scale: 0
            }} animate={{
              scale: 1
            }} className="absolute -top-1 -right-1 w-2.5 h-2.5 bg-[#D4A017] rounded-full border-2 border-white" data-id="element-18" />}
              </div>

              <motion.span animate={{
            y: isActive ? -1 : 0,
            opacity: isActive ? 1 : 0.8
          }} className={`text-[11px] tracking-wide ${isActive ? 'font-bold' : 'font-medium'}`} data-id="element-19">
                {tab.label}
              </motion.span>
            </button>;
      })}
      </div>
    </div>;
}